import JCTaskSummary from "./taskDetailsJobCard/JCTaskSummary";
var TaskSummary = function (props) {
    var onCrossClick = props.onCrossClick, id = props.id, jobCardData = props.jobCardData, isCrossIcon = props.isCrossIcon, isHeaderShown = props.isHeaderShown;
    return /*#__PURE__*/ React.createElement(JCTaskSummary, {
        onCrossClick: onCrossClick,
        jobCardId: id,
        jobCardData: jobCardData,
        isCrossIcon: isCrossIcon,
        isHeaderShown: isHeaderShown
    });
};
export default TaskSummary;
